import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const BetterFirstSessionIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      viewBox='0 0 32 32' fill={theme.palette.text.primary}
      height={props.width} width={props.width} xmlns='http://www.w3.org/2000/svg' id='fi_4212269'
    >
      <g id='_14-Loss' data-name='14-Loss'>
        <path
          d='m27.38 11.08a1 1 0 0 0 -1.09.21l-1.79 1.8-5.79-5.8a1 1 0 0 0 -1.42 0l-3.29 3.3-8.29-8.3a1 1 0 0 0 -1.42 1.42l9 9a1 1 0 0 0 1.42 0l3.29-3.3 5.09 5.09-1.8 1.79a1 1 0 0 0 -.21 1.09 1 1 0 0 0 .92.62h5a1 1 0 0 0 1-1v-5a1 1 0 0 0 -.62-.92z'
        />
        <rect height='9' rx='1' width='6' x='22' y='21' />
        <rect height='13' rx='1' width='6' x='13' y='17' />
        <rect height='17' rx='1' width='6' x='4' y='13' />
      </g>
    </svg>
  )
}
export default BetterFirstSessionIcon
